import { render, staticRenderFns } from "./DevMaintainceTaskListForPerson.vue?vue&type=template&id=22954aea&scoped=true&"
import script from "./DevMaintainceTaskListForPerson.vue?vue&type=script&lang=js&"
export * from "./DevMaintainceTaskListForPerson.vue?vue&type=script&lang=js&"
import style0 from "./DevMaintainceTaskListForPerson.vue?vue&type=style&index=0&id=22954aea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22954aea",
  null
  
)

export default component.exports